module.exports = __webpack_public_path__ + "static/img/5.2c21178c.png";